import React from 'react';

export function Footer() {
    return (
        <footer className="app-footer">
            <div className="footer-content">
                <span>© {new Date().getFullYear()} TetraCom - TimelineMKT</span>
            </div>
            <style>{`
                .app-footer {
                    background-color: #f8f9fa;
                    border-top: 1px solid #e9ecef;
                    padding: 12px 20px;
                    text-align: center;
                    font-size: 0.85rem;
                    color: #6c757d;
                    margin-top: auto;
                    width: 100%;
                    box-sizing: border-box;
                }
                .footer-content {
                    max-width: 1400px;
                    margin: 0 auto;
                }
            `}</style>
        </footer>
    );
}
